import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('components.QBooksMatchingPopup.MatchingPopupLinks', {
    learMoreText: 'ApprovalMax allows to manually match incoming Bills with the Purchase Orders. {learnMoreLink}',
    learnMoreLinkText: 'Learn more',
    videoText: 'See {videoLink} on How to match Bills with Purchase Orders',
    videoUrl: 'video',
});
